import { createFileRoute } from '@tanstack/react-router';

// relative imports
import ReportsPageContainer from '../../../../../components/reports/ReportsPageContainer';
import LoadingPage from '../../../../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/reports',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ReportsPageContainer,
  staticData: {
    configPageId: 'reports',
    isClientRoute: true,
    meta: {
      title: 'Client Reports | Ledgible',
    },
  },
});
